import React from 'react';

export const ChevronRightLg = ({ title }: { title: string }): JSX.Element => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <title>{title}</title>
    <g clipPath='url(#clip0_18636_18224)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.29297 22L17.293 12L7.29297 2.00005L8.00008 1.29294L18.7072 12L8.00008 22.7072L7.29297 22Z'
        fill='#5F708B'
      />
    </g>
    <defs>
      <clipPath id='clip0_18636_18224'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
